
jQuery( function( $ ) {
	let tallest = 0;

	$( '.work-items li a.title' ).each( function() { // Services Pages, get tallest title
		if ( $( this ).height() > tallest ) {
			tallest = $( this ).height();
		}
	} );

	$( '.work-items li a.title' ).each( function() { // Set all titles to height of tallest title
		$( this ).css( 'height', tallest + 'px' );
	} );

	$( function() { // Engineering & Field Services Page, Set Equal Service Section Heights
		if ( $( 'body' ).hasClass( 'page-id-38' ) || $( 'body' ).hasClass( 'page-id-52' ) ) {
			$( '.services ul li' ).matchHeight();
		}
	} );
} ); // end document ready

jQuery( window ).on( 'resizeEnd', function( $ ) {
	$( function() { // Engineering & Field Services Page, Set Equal Service Section Heights
		if ( $( 'body' ).hasClass( 'page-id-38' ) || $( 'body' ).hasClass( 'page-id-52' ) ) {
			$( '.services ul li' ).matchHeight();
		}
	} );
} );

